var _defs, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIconText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#053491;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1841"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.06,
    y: 2.06,
    width: 115.87,
    height: 115.87,
    rx: 21.07,
    ry: 21.07
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.07,38.93H38.93c-1.46,0-2.63,1.18-2.63,2.63v7.9c0,1.46,1.18,2.63,2.63,2.63s2.63-1.18,2.63-2.63v-5.27h15.8v36.87h-5.27c-1.46,0-2.63,1.18-2.63,2.63s1.18,2.63,2.63,2.63h15.8c1.46,0,2.63-1.18,2.63-2.63s-1.18-2.63-2.63-2.63h-5.27V44.2h15.8v5.27c0,1.46,1.18,2.63,2.63,2.63s2.63-1.18,2.63-2.63v-7.9c0-1.46-1.18-2.63-2.63-2.63Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIconText);
export default __webpack_public_path__ + "static/media/media-icon-text.1634671547669ca9c2bc6356c0d8b605.svg";
export { ForwardRef as ReactComponent };